import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { PortalModule } from './portal/portal.module';

// Comes from mode.js
if (window['__env'].production) {
  enableProdMode();
}
const path = window.location.pathname;

if (path.startsWith('/portal')) {
  platformBrowserDynamic()
    .bootstrapModule(PortalModule)
    .catch((err) => console.error(err));
} else {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}
